import { trackingUtils } from '@debijenkorf/dbk-common';

type TRACK_SEARCH_RESULT = {
  searchTerm: string;
  searchResult: number;
};

export const trackSearchResult = ({ searchTerm, searchResult }: TRACK_SEARCH_RESULT) => {
  // GTM is done afterInteractive. This causes the window.dataLayer to be undefined on mount
  setTimeout(() => {
    trackingUtils.pushToDataLayer({
      event: 'search_result',
      search_term: searchTerm,
      search_result: searchResult,
    });
  }, 0);
};
